export const colorOrders = ["RGB", "RBG", "GRB", "GBR", "BRG", "BGR"] as const;
const permutations = [[0, 1, 2], [0, 2, 1], [1, 0, 2], [1, 2, 0], [2, 0, 1], [2, 1, 0]] as const;
const baseColors = [[0.53, 0.32, 0.15], [0.30, 0.44, 0.26], [0.21, 0.31, 0.48]] as const;
const primaries = [[1, 0, 0], [0, 1, 0], [0, 0, 1]] as const;

export function clamp01(value: number): number { return Math.max(0, Math.min(1, value)); }
export function encodeColorMapping(orderIndex: number, inversionMask: number): number {
  return Math.max(0, Math.min(5, Math.round(orderIndex))) * 8 + (Math.max(0, Math.min(7, Math.round(inversionMask))));
}
export function decodeColorMapping(combination: number): { orderIndex: number; inversionMask: number; order: string; permutation: readonly number[] } {
  const normalized = Math.max(0, Math.min(47, Math.round(combination)));
  const orderIndex = Math.floor(normalized / 8);
  return { orderIndex, inversionMask: normalized % 8, order: colorOrders[orderIndex], permutation: permutations[orderIndex] };
}
export function blendBasisColors(blend: number): number[][] {
  const amount = clamp01(blend);
  return baseColors.map((color, index) => color.map((value, channel) => value + (primaries[index][channel] - value) * amount));
}
export function composeMappedColor(outputs: readonly number[], combination: number, blend: number): number[] {
  const mapping = decodeColorMapping(combination);
  const weights = mapping.permutation.map((source, channel) => {
    const signed = (mapping.inversionMask & (1 << channel)) !== 0 ? -outputs[source] : outputs[source];
    return clamp01(signed * 0.5 + 0.5);
  });
  const basis = blendBasisColors(blend);
  return [0, 1, 2].map(channel => clamp01(weights[0] * basis[0][channel] + weights[1] * basis[1][channel] + weights[2] * basis[2][channel]));
}
